import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { disableWorkspaceCode } from '../../../../api/workspaces/invite/disableWorkspaceCode';

export function useDisableWorkspaceCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: disableWorkspaceCode,
    onSettled: (_data, _error, { workspaceId, workspaceRole }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
    onMutate: ({ workspaceId, workspaceRole }) => {
      queryClient.removeQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
    onError: () => {
      //console.log('error');
    },
  });
}
